// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/morgans/v1/opportunity_watch.proto (package mono.morgans.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { GetOpportunityActivityRequest, GetOpportunityActivityResponse, GetOpportunityWatchRequest, GetOpportunityWatchResponse, ListOpportunityActivityRequest, ListOpportunityActivityResponse, SetOpportunityWatchRequest, SetOpportunityWatchResponse } from "./opportunity_watch_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Principal-scoped browser adapter. All methods authorize through the same
 * fail-closed tenant-root resolver as SAD-469 before accessing pangaea.
 *
 * @generated from service mono.morgans.v1.OpportunityWatchService
 */ export const OpportunityWatchService = {
    typeName: "mono.morgans.v1.OpportunityWatchService",
    methods: {
        /**
     * @generated from rpc mono.morgans.v1.OpportunityWatchService.GetOpportunityWatch
     */ getOpportunityWatch: {
            name: "GetOpportunityWatch",
            I: GetOpportunityWatchRequest,
            O: GetOpportunityWatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.OpportunityWatchService.SetOpportunityWatch
     */ setOpportunityWatch: {
            name: "SetOpportunityWatch",
            I: SetOpportunityWatchRequest,
            O: SetOpportunityWatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.OpportunityWatchService.ListOpportunityActivity
     */ listOpportunityActivity: {
            name: "ListOpportunityActivity",
            I: ListOpportunityActivityRequest,
            O: ListOpportunityActivityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.morgans.v1.OpportunityWatchService.GetOpportunityActivity
     */ getOpportunityActivity: {
            name: "GetOpportunityActivity",
            I: GetOpportunityActivityRequest,
            O: GetOpportunityActivityResponse,
            kind: MethodKind.Unary
        }
    }
};
